angular.module('taric.us', [])
    .config(['$routeProvider', routeConfigurator])
    // Components
    .component('usMeasuresPage', require('./components/us-measures-page'))
    .component('aboutTheHtsPage', require('./components/about-the-hts-page'))
    .component('htsGeneralNotesPage', require('./components/hts-general-notes-page'))
    .component('htsAppendicesPage', require('./components/hts-appendices-page'))
    .component('htsNonChapterSection', require('./components/hts-non-chapter-section'))
    .component('scheduleBGeneralNotesPage', require('./components/schedule-b-general-notes-page'))
    .component('scheduleBGeneralNotes', require('./components/schedule-b-general-notes'))
    // Modals
    // Services
    .factory('usTariffDataService', require('./services/us-tariff-data'))
    .factory('scheduleBDataService', require('./services/schedule-b-data'))
    .factory('htsOtherSectionsDataService', require('./services/hts-other-sections-data'))
    ;


function routeConfigurator($routeProvider) {
    $routeProvider
        .when('/us-measures/:commodityCode', {
            template: '<us-measures-page></us-measures-page>'
        })
        .when('/about-the-hts', {
            template: '<about-the-hts-page></about-the-hts-page>'
        })
        .when('/hts-general-notes', {
            template: '<hts-general-notes-page></hts-general-notes-page>'
        })
        .when('/hts-appendices', {
            template: '<hts-appendices-page></hts-appendices-page>'
        })
        .when('/schedule-b-general-notes', {
            template: '<schedule-b-general-notes-page></schedule-b-general-notes-page>'
        })
    ;
}
